module.exports = __webpack_public_path__ + "static/media/fertilize.a25e3f1b.svg";